var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSignoutArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.908,
    height: 13.804,
    viewBox: "0 0 12.908 13.804",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#65686b;stroke-linecap:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-81.592 -725.586)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.962 712.956)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 7.761,
    transform: "translate(62.532 14.044) rotate(45)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    y2: 7.761,
    transform: "translate(62.532 25.02) rotate(135)"
  })), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 10,
    transform: "translate(83.5 732.5)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSignoutArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/signout_arrow.e8b600ce.svg";
export { ForwardRef as ReactComponent };